/**
 * 押すと大きく開くカードの画像（Issue #930）。開いた画像は外側を押すか Esc で閉じる。
 */
import { useEffect, useState } from 'react';

export function ImageLightbox({ src, alt, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="modal-overlay" data-testid="image-lightbox" onClick={onClose} style={{ cursor: 'zoom-out' }}>
      <img src={src} alt={alt}
        style={{ maxWidth: '95vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8, boxShadow: '0 4px 24px #000a' }} />
    </div>
  );
}

export default function ZoomableImage({ src, alt, style, testId }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <img src={src} alt={alt} data-testid={testId} title="押すと大きく開く"
        style={{ width: 80, flexShrink: 0, borderRadius: 4, cursor: 'zoom-in', ...style }}
        onClick={() => setOpen(true)} />
      {open && <ImageLightbox src={src} alt={alt} onClose={() => setOpen(false)} />}
    </>
  );
}
